import { Route } from "@soft-db/typed-router";

const auditRoute = new Route({
	name: "audit",
	path: "audit",
	meta: {
		feature: "audit",
	},
	component: () => import("@/pages/audit/audit.vue"),
});

export default auditRoute;
